import React, { useState, useCallback } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const Lightbox = ({ images, initialIndex = 0, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  const handlePrev = useCallback(() => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  }, [images.length]);

  const handleNext = useCallback(() => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  }, [images.length]);

  React.useEffect(() => {
    const keyHandler = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') handlePrev();
      if (e.key === 'ArrowRight') handleNext();
    };
    document.addEventListener('keydown', keyHandler);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', keyHandler);
      document.body.style.overflow = 'unset';
    };
  }, [onClose, handlePrev, handleNext]);

  return (
    <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center">
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 p-2 text-white/70 hover:text-white transition-colors duration-300 z-10"
      >
        <X className="w-8 h-8" />
      </button>

      {/* Navigation - Prev */}
      <button
        onClick={handlePrev}
        className="absolute left-4 p-3 text-white/70 hover:text-white bg-black/30 hover:bg-black/50 rounded-full transition-all duration-300 z-10"
      >
        <ChevronLeft className="w-8 h-8" />
      </button>

      {/* Image */}
      <div className="w-full h-full flex items-center justify-center p-16">
        <img
          src={images[currentIndex]}
          alt={`Görsel ${currentIndex + 1}`}
          className="max-w-full max-h-full object-contain animate-fade-in"
        />
      </div>

      {/* Navigation - Next */}
      <button
        onClick={handleNext}
        className="absolute right-4 p-3 text-white/70 hover:text-white bg-black/30 hover:bg-black/50 rounded-full transition-all duration-300 z-10"
      >
        <ChevronRight className="w-8 h-8" />
      </button>

      {/* Counter */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/70 text-sm">
        {currentIndex + 1} / {images.length}
      </div>

      {/* Thumbnails */}
      <div className="absolute bottom-16 left-1/2 -translate-x-1/2 flex items-center space-x-2 max-w-[90vw] overflow-x-auto py-2">
        {images.map((img, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`flex-shrink-0 w-16 h-12 rounded overflow-hidden border-2 transition-all duration-300 ${
              index === currentIndex
                ? 'border-gold opacity-100'
                : 'border-transparent opacity-50 hover:opacity-100'
            }`}
          >
            <img src={img} alt="" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default Lightbox;